var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var AbstractIpcPadGeneratorInteractionModel = require("../abstractIpcPadGeneratorInteractionModel.js");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var IpcPthPadGeneratorInteractionModel = function(data, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    AbstractIpcPadGeneratorInteractionModel.call(this, data, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(IpcPthPadGeneratorInteractionModel, AbstractIpcPadGeneratorInteractionModel);
IpcPthPadGeneratorInteractionModel.$class = 'IpcPthPadGeneratorInteractionModel';
module.exports = IpcPthPadGeneratorInteractionModel;

IpcPthPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    AbstractIpcPadGeneratorInteractionModel.prototype.initialize.call(this);

    /*
        component densities
     */
    for (var d in cio_datamodel.IpcDataModel.PthComponentAttribute.densityLevel) {
        this.componentDensityList.push([this.LCLZ(d,d), cio_datamodel.IpcDataModel.PthComponentAttribute.densityLevel[d]]);
    }

    /*
       pad Shapes
     */
    for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.padShapes) {
        var s = cio_datamodel.IpcDataModel.PthComponentAttribute.padShapes[t];
        if (s != cio_datamodel.IpcDataModel.PthComponentAttribute.padShapes["RoundedSquare"]) {
            this.padShapeList.push([this.LCLZ(t, s), s]);
        }
    }    

    this.terminalWidth = this.shadow("terminalWidth",
        function() {
            return self.data.terminalWidth() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value) * self.getUnitFactor();

            if(self.data instanceof cio_datamodel.IpcDataModel.AxialData) {
                self.terminalLength(value);
            }

            return self.data.terminalWidth(value);
        },
        [
            self.data.terminalWidth, self.userSettingsModel.distanceUnit
        ]
    );

    this.terminalLength = this.shadow("terminalLength",
        function() {
            return self.data.terminalLength() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);
            return self.data.terminalLength(value * self.getUnitFactor());
        },
        [
            self.data.terminalLength, self.userSettingsModel.distanceUnit
        ]
    );

    this.padToHoleRatio = this.shadow("padToHoleRatio",
        function() {
            return self.data.padToHoleRatio();
        },
        function(value) {
            value = parseFloat(value);
            return self.data.padToHoleRatio(value);
        },
        [
            self.data.padToHoleRatio
        ]
    );
};

IpcPthPadGeneratorInteractionModel.prototype.getInspectorName = function() {
    var name = '';

    switch(this.data.constructor) {
        case cio_datamodel.IpcDataModel.AxialData:
            name = this.LCLZ("AXIAL", "Axial");
        break;

        case cio_datamodel.IpcDataModel.DipData:
            name = this.LCLZ("DIP", "DIP");
        break;

        case cio_datamodel.IpcDataModel.HeaderStraightData:
            name = this.LCLZ("PIN_HEADER_STRAIGHT", "Pin Header (Male) Straight");
        break;

        case cio_datamodel.IpcDataModel.HeaderRightAngleData:
            name = this.LCLZ("PIN_HEADER_RA", "Pin Header (Male) Right Angle");
        break;

        case cio_datamodel.IpcDataModel.HeaderStraightSocketData:
            name = this.LCLZ("RECEPTACLE_HEADER_STRAIGHT", "Receptacle Header (Female) Straight");
        break;

        case cio_datamodel.IpcDataModel.HeaderRightAngleSocketData:
            name = this.LCLZ("RECEPTACLE_HEADER_RA", "Receptacle Header (Female) Right Angle");
        break;

        case cio_datamodel.IpcDataModel.RadialRoundData:
            name = this.LCLZ("RADIAL_GENERIC", "Radial Generic (Round)");
        break;

        case cio_datamodel.IpcDataModel.RadialLedRoundData:
            name = this.LCLZ("RADIAL_LED", "Radial LED (Round)");
        break;

        case cio_datamodel.IpcDataModel.CrystalHC49Data:
            name = this.LCLZ("CRYSTAL_HC49", "Crystal (HC49)");
        break;

        case cio_datamodel.IpcDataModel.FemaleStandoffSpacerData:
            name = this.LCLZ("FEMALE_STANDOFF", "Female Standoff/Spacer");
        break;

        case cio_datamodel.IpcDataModel.MaleFemaleStandoffSpacerData:
            name = this.LCLZ("MALE_FEMALE_STANDOFF", "Male-Female Standoff");
        break;

        case cio_datamodel.IpcDataModel.SnapLockData:
            name = this.LCLZ("SNAP_LOCK", "Snap Lock");
        break;
    }

    return name;
};

IpcPthPadGeneratorInteractionModel.prototype.getInspectorElementForPadHoleRatio = function() {
    return [PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('padToHoleRatio', 'Pad to Hole Ratio'), this.padToHoleRatio, this.showFootprintParams)];
};

IpcPthPadGeneratorInteractionModel.prototype.getInspectorElementForDensityLevel = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('producibilityLevel', 'Producibility Level'), this.densityLevel, this.componentDensityList, this.showFootprintParams)];
};

IpcPthPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), true, null, false, this.terminalWidth, this.userSettingsModel.distanceUnit)];
};

IpcPthPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), true, null, false, this.terminalLength, this.userSettingsModel.distanceUnit)];
};
